<div>
	@if (body.anEigentuemerNeuSenden) {
		<span data-test-id="eigentuemer-neu">Eigentümer neu {{ eigentuemerNeu }}</span>
	}
	@if (body.anEigentuemerAltSenden) {
		<span data-test-id="eigentuemer-alt">Eigentümer alt {{ eigentuemerAlt }}</span>
	}
	@if (body.anEingetragenerEigentuemerSenden) {
		<span data-test-id="eingetragener-eigentuemer">Eingetragener Eigentümer {{ eingetragenerEigentuemer }}</span>
	}
	@if (body.anGlaeubigerNeuSenden) {
		<span data-test-id="glaeubiger-neu">Gläubiger neu {{ glaeubigerNeu }}</span>
	}
	@if (body.anGlaeubigerAltSenden) {
		<span data-test-id="glaeubiger-alt">Gläubiger alt {{ glaeubigerAlt }}</span>
	}
	@if (body.anNotarSenden) {
		<span data-test-id="notar">Notar {{ notar }}</span>
	}
	@if (body.anBehoerdenSenden) {
		<span data-test-id="behoerden">Behörden</span>
	}
	@if (body.anBshSenden) {
		<span data-test-id="bsh">{{ mitteilungEmpfaenger.BSH }} {{ bsh }}</span>
	}
	@if (body.anRechtsanwaelteSenden) {
		<span data-test-id="rechtsanwaelte">Rechtsanwälte {{ rechtsanwaelte }}</span>
	}
</div>
